import { render } from "./latest-releases.vue?vue&type=template&id=3fd19d04"
import script from "./latest-releases.vue?vue&type=script&lang=ts"
export * from "./latest-releases.vue?vue&type=script&lang=ts"
script.render = render

export default script